import React from "react";
import "./navbar.css"
import logo from "../../assets/logo.png";
import menu from "../../assets/menu.svg";
import close from "../../assets/close.svg";
import $ from 'jquery';
import {Link} from "react-router-dom";

const Navbar = () => {
    $(document).ready(function(){
        $("#links p").hide();
        $("#close").hide();
        $("#hamburger").click(function(){
            $("#canvas").fadeIn().delay(200);
            $("#links p").slideDown();
            $("#hamburger").hide();
            $("#close").show();
        });
        $("#close").click(function(){
            $("#canvas").fadeOut().delay(200);
            $("#links p").slideUp();
            $("#hamburger").show();
            $("#close").hide();
        });

        $(".navclick").click(function(){
            $("#canvas").fadeOut().delay(200);
            $("#links p").slideUp();
            $("#hamburger").show();
            $("#close").hide();
        });
    });

    const scrollTop = () => {
        window.scrollTo(0, 0);
    }

    return (

    <div>
        <div id="navpc">
            <img src={logo} id="logopc" alt=""/>
            <ul>
                <Link to="/" style={{textDecoration: "none"}} onClick={scrollTop}><li>Home</li></Link>
                <Link to="/about" style={{textDecoration: "none"}} onClick={scrollTop}><li>About</li></Link>
                <Link to="/gallery" style={{textDecoration: "none"}} onClick={scrollTop}><li>Gallery</li></Link>
                <Link to="/rooms" style={{textDecoration: "none"}} onClick={scrollTop}><li id="last">Rooms</li></Link>
                <a href="https://booking.com" rel="noreferrer" target="_blank"><button className="bookbutton">Book a room</button></a>
            </ul>
        </div>

        <div id="navmobile">
            <img src={logo} id="logomob" alt="" />
            <img src={menu} id="hamburger" alt="" />
        </div>

        <div id="canvas">
            <div id="headercanvas">
                <div id="navmobile">
                    <img src={logo} id="logomob" alt="" />
                    <img src={close} id="close" alt="" />
                </div>
            </div>
            <div id="bodycanvas">
                <div id="links">
                    <Link className="navclick" to="/" style={{textDecoration: "none"}}><p>Home</p></Link>
                    <Link className="navclick" to="/about" style={{textDecoration: "none"}}><p>About</p></Link>
                    <Link className="navclick" to="/gallery" style={{textDecoration: "none"}}><p>Gallery</p></Link>
                    <Link className="navclick" to="/rooms" style={{textDecoration: "none"}}><p>Rooms</p></Link>
                    <a href="https://booking.com" rel="noreferrer" target="_blank"><button className="bookbutton">Book a room</button></a>
                </div>
            </div>
        </div>
    </div>
    );
}
 
export default Navbar;